class Alert extends DrupalBehavior {

  onContent() {
    
    super.onReady();
    var cookiesObj = {};

    if (Cookies.get('alertClosed') != undefined) {
      cookiesObj = Cookies.getJSON('alertClosed');
    }

    $('.alert-message').each(function (ix, elem) {
      var nid = $(this).attr('data-nid');
      if (cookiesObj[nid] !== undefined) {
        $(this).addClass('hidden');
      }
      else {
        // triggered on page load; an alert is on the page and it will be displayed
        $(this).removeClass('hidden');
      }
      $(this).find('.close-alert').on('click', function (e) {
        // triggered on [X] click; the alert was opened but should be closed
        e.preventDefault();
        var nid = $(this).attr('data-nid');
        $('.alert-message').slideUp('fast');
        cookiesObj[nid] = nid;
        Cookies.set('alertClosed', cookiesObj);
      });
    });
  }

}

DrupalBehavior.register('guthrie_theme', 'alert', Alert);
